import { setContext } from 'apollo-link-context';
import { ApolloLink } from 'apollo-link';
import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';

import firebase from 'firebase/app';

import { apiHost } from '../config';

const DEFAULT_VIDEO_THUMBNAIL =
  'https://i.vimeocdn.com/video/499134794_1280x720.jpg';
export async function uploadMedia({ file, accessToken, streaming = false }) {
  let uploadUrl = `${apiHost}/v1/media/upload_presigned_post_url`;
  let transcodeUrl = `${apiHost}/v1/media/transcode`;

  console.log(`POST ${uploadUrl}`);
  console.log(file);
  const res = await fetch(uploadUrl, {
    method: 'POST',
    credentials: 'include',
    body: JSON.stringify({
      size: file.size,
      name: file.name,
      type: file.type,
    }),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  });

  const parsed = await res.json();
  const uploadHost = parsed.data.url;
  const fields = parsed.data.fields;

  console.log(uploadHost);
  console.log(fields);

  // BEING upload to s3 here
  let formData = new FormData();
  Object.keys(fields).forEach((key) => {
    formData.append(key, fields[key]);
  });
  formData.append('file', file);

  const s3UploadResponse = await fetch(uploadHost, {
    method: 'POST',
    body: formData,
  });
  console.log(s3UploadResponse);
  // End upload to s3

  let uploadedRes = {};
  const uploadedUrl = `${uploadHost}/${fields.key}`;
  console.log(uploadedUrl);

  if (file.type.startsWith('video')) {
    const transcodeResponse = await fetch(transcodeUrl, {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify({
        url: uploadedUrl,
        streaming,
      }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    });
    if (!transcodeResponse.ok) {
      throw new Error(transcodeResponse.statusText);
    }

    const parsedTranscodeResponse = await transcodeResponse.json();
    const videos = parsedTranscodeResponse.uploaded[0]?.files.map((f) => ({
      contentType: f.contentType,
      url: f.url,
      imageUrl: f.imageUrl,
    }));

    const uploaded = videos[0];
    if (!uploaded) {
      throw new Error('Could not transcode video.');
    }
    const thumbnailUrl = uploaded.imageUrl;

    uploadedRes.image = { url: thumbnailUrl || DEFAULT_VIDEO_THUMBNAIL };
    uploadedRes.videos = videos;
  } else {
    uploadedRes.image = { url: uploadedUrl };
  }

  // {image: {url}, video: {url}}
  return uploadedRes;
}

export async function toBase64(file) {
  return new Promise(async (resolve, reject) => {
    const reader = new FileReader();
    if (/\.(jpe?g|png|gif)$/i.test(file.name)) {
      reader.readAsDataURL(file);
    } else {
      const data = await fetch(DEFAULT_VIDEO_THUMBNAIL);
      const blob = await data.blob();
      reader.readAsDataURL(blob);
    }

    reader.onload = () => {
      const img = new Image();

      img.onload = () => {
        resolve({
          data: reader.result,
          width: img.width,
          height: img.height,
          type: file.type,
        });
      };
      img.src = reader.result;
    };
    reader.onerror = (error) => reject(error);
  });
}

export async function fetchPostJSON(url, data, authToken) {
  const opts = {
    method: 'POST', // *GET, POST, PUT, DELETE, etc.
    mode: 'cors', // no-cors, *cors, same-origin
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: 'same-origin', // include, *same-origin, omit
    headers: {
      'Content-Type': 'application/json',
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: 'follow', // manual, *follow, error
    referrerPolicy: 'no-referrer', // no-referrer, *client
    body: JSON.stringify(data || {}), // body data type must match "Content-Type" header
  };
  opts.headers['Authorization'] = `Bearer ${authToken}`;
  // Default options are marked with *
  const response = await fetch(url, opts);
  const json = await response.json(); // parses JSON response into native JavaScript objects

  json.statusCode = response.status;

  return json;
}

// https://github.com/apollographql/apollo-feature-requests/issues/6#issuecomment-676886539
const cleanTypeName = new ApolloLink((operation, forward) => {
  if (operation.variables) {
    const omitTypename = (key: string, value: any) =>
      key === '__typename' ? undefined : value;
    operation.variables = JSON.parse(
      JSON.stringify(operation.variables),
      omitTypename
    );
  }
  return forward(operation).map((data) => {
    return data;
  });
});

export function createApolloClient() {
  const httpLink = createHttpLink({
    uri: `${apiHost}/graphql`,
  });
  const authLink = setContext(async (_, { headers }) => {
    const token = await firebase.auth().currentUser?.getIdToken();
    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : null,
      },
    };
  });

  const client = new ApolloClient({
    link: ApolloLink.from([cleanTypeName, authLink, httpLink]),
    cache: new InMemoryCache({ addTypename: false }),
  });

  return client;
}
